import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import makeUid from 'uid';
import { formValueSelector } from '../../features/form';
import { validateRequest } from '../../features/form-error/actions';
import { getValidating, hasError, getMessage } from '../../features/form-error/selectors';
import { getCompleteOrder } from '../../features/selectors';
import { logEvent, getAcceptAlkhol, setSubmitAlcoholError } from '../../features/user';
import { setOrder } from '../../features/order';
import { getPaymentType, paymentTypes } from '../../features/commerce/payment';
import { getItemInconsistensies, getItemChangeEntries, getItemAlcoholLevel } from '../../features/commerce/selectors';
import { setItemAmount, setItemSingleAmount } from '../../features/commerce/bucket/actions';
import { setItemsWithConversion } from '../../features/commerce/items';
import { isInSpecialMode } from '../../features/commerce/delivery';
import getArg from '../../lib/args';
import { ga, fbq } from '../../lib/analytics';
import getPaymentWindow from '../../lib/payment';
import { LinkButton } from '../../components/typography';

const invoiceFormSelector = formValueSelector('invoice-details');
const errorMappings = {
  CUSTOMER_ORDER_VERSION_ID_NOT_POSSIBLE: 'Der skete en fejl, opdater siden og prøv igen',
  UNKNOWN_ERROR: 'Der skete en fejl med din bestilling. Vi har modtaget en fejlrapport af fejlen på hjemmesiden og vil rette den hurtigst muligt. Ring til os på 43 27 00 00 og foretag din bestilling.',
};
const standardMessage = 'Der skete en fejl med din bestilling. Vi har modtaget en fejlrapport af fejlen på hjemmesiden og vil rette den hurtigst muligt. Ring til os på 43 27 00 00 og foretag din bestilling.';
const genericErrorMessage = 'Noget gik galt i systemet ved din bestilling. Vi har modtaget en fejlrapport, som vi vil gennemgå hurtigst muligt, for at løse fejlen på siden. Du kan i mellemtiden prøve at opdatere siden og bestille igen, bruge en anden browser eller kontakte os på tlf 43 27 00 00 eller peter@skafte.dk. Vi beklager ulejligheden.';
const noChangeEntriesText = 'Nogle priser har ændret sig. Priserne er blevet opdateret og du kan forsøge at bestille igen';
const generateChangeEntriesText = changeEntries => `Følgende priser har ændret sig \n\n${changeEntries.join('\n\n')}\n\nPriserne er blevet opdateret og du kan forsøge at bestille igen`;


class OrderSubmitButton extends React.Component {
  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
    this.state = {
      validating: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    const { validating, bookingUid } = this.state;
    if (validating) {
      if (!nextProps.validating) {
        this.setState({ validating: false }, () => {
          const {
            logEvent,
          } = this.props;
          if (nextProps.error) {
            logEvent({
              type: 'BOOKING_FAILED_VALIDATION',
              bookingUid,
              message: nextProps.message,
            });
            window.alert(nextProps.message); // eslint-disable-line
            this.setState({ submitting: false, bookingUid: null });
            return;
          }
          logEvent({
            type: 'BOOKING_SUCCEDED_VALIDATION',
            bookingUid,
          });
           fbq('track', 'InitiateCheckout');
          const { state, paymentMethod } = this.props;
          const order = {
            ...getCompleteOrder(state),
            bookingUid,
          };
          logEvent({
            type: 'BOOKING_SUCCEDED_GET_COMPLETE_ORDER',
            bookingUid,
            total: order.total,
            itemEntries: order.itemEntries,
          });
          const timeout = 20000;
          // validate order
          if (paymentMethod === paymentTypes.card) {
            window.axios.post('/api/order/reserve', order, { timeout }) // eslint-disable-line
              .then(({ data }) => {
                logEvent({
                  type: 'BOOKING_SUCCEDED_SERVER_REQUEST',
                  bookingUid,
                });
                ga('event', 'open', { event_category: 'PayWindow' });
                if (window.location.origin.indexOf('localhost') === -1) { // eslint-disable-line
                  const paymentWindowProps = {
                    orderid: data.textId,
                    merchantnumber: getArg('epayMerchantNumber'),
                    amount: order.total,
                    currency: 'DKK',
                    paymentcollection: 0,
                    mobile: '1',
                    ownreceipt: 1,
                  };
                  if (window.location.origin.indexOf('localhost') === -1) { // eslint-disable-line
                    paymentWindowProps.accepturl = `${window.location.origin}/bestil/ordre/accept/${data.orderRef}`; // eslint-disable-line
                    paymentWindowProps.callbackurl = `${window.location.origin}/api/epaycallback/${data.orderRef}`; // eslint-disable-line
                    paymentWindowProps.cancelurl = `${window.location.origin}/bestil/detaljer`; // eslint-disable-line
                  }
                  getPaymentWindow(
                    (PaymentWindow) => {
                      logEvent({
                        type: 'BOOKING_SUCCEDED_GET_PAYMENT_WINDOW',
                        bookingUid,
                      });
                      const paymentwindow = new PaymentWindow(paymentWindowProps);
                      paymentwindow.open();
                      window.scrollTo(0, 0); // eslint-disable-line
                    },
                  );
                } else {
                  const { history } = this.props;
                  history.push(`/bestil/ordre/accept/${data.orderRef}?txnid=1337&txnfee=100&amount=${order.total}&paymenttype=VISA`);
                }
                this.setState({ submitting: false });
              })
              .catch((e) => {
                if (window.__ON_ORDER_COMPLETE__) { // eslint-disable-line
                  window.__ON_ORDER_COMPLETE__(false); // eslint-disable-line
                }
                if (e.response) {
                  const {
                    response: {
                      data,
                    },
                  } = e;
                  logEvent({
                    type: 'BOOKING_SERVER_REQUEST_FAILED_WITH_REPONSE_DATA',
                    bookingUid,
                  });
                  const {
                    errors,
                    resources,
                  } = data;
                  logEvent({
                    type: 'BOOKING_FAIL_DATA',
                    bookingUid,
                    errors,
                  });
                  if (errors[0].type === 'CUSTOMER_TOTAL_DOES_NOT_MATCH_CALCULATION') {
                    const {
                      order: actualOrder,
                      products,
                      productVersion,
                    } = resources;
                    // Figure out what items changed
                    // eslint-disable-next-line react/destructuring-assignment
                    const changeEntries = getItemChangeEntries(this.props.state, actualOrder);
                    if (changeEntries.length === 0) {
                      window.alert(noChangeEntriesText); // eslint-disable-line
                    }
                    // alert the customer
                    window.alert(generateChangeEntriesText(changeEntries)); // eslint-disable-line
                    // Reset products
                    // eslint-disable-next-line react/destructuring-assignment
                    this.props.setItemsWithConversion(products, productVersion);
                  } else {
                    const errorTexts = errors.map(
                      ({ type }) => errorMappings[type] || standardMessage,
                    ).join('\n\n');
                    window.alert(errorTexts); // eslint-disable-line
                  }
                } else if (e.request) {
                  if (e.code === 'ECONNABORTED') {
                    logEvent({
                      type: 'BOOKING_SERVER_REQUEST_FAILED_BECAUSE_OF_TIMEOUT',
                      bookingUid,
                    });
                  } else {
                    logEvent({
                      type: 'BOOKING_SERVER_REQUEST_FAILED_WITHOUT_BECAUSE_OF_BROWSER',
                      bookingUid,
                    });
                    window.alert(genericErrorMessage) // eslint-disable-line
                  }
                } else {
                  logEvent({
                    type: 'BOOKING_SERVER_REQUEST_FAILED_BECAUSE_OF_UNKNOWN_REASON',
                    bookingUid,
                  });
                  window.alert(genericErrorMessage) // eslint-disable-line
                }
                this.setState({ submitting: false, bookingUid: null });
              });
          } else {
            window.axios.post('/api/order/submit', order, { timeout }) // eslint-disable-line
              .then(({ data: order }) => {
                logEvent({
                  type: 'BOOKING_SUCCEDED_SERVER_REQUEST',
                  bookingUid,
                });
                const { setOrder, history } = this.props;
                setOrder(order);
                history.push(`/bestil/ordre/accept/${order.orderRef}`);
              })
              .catch((e) => {
                if (window.__ON_ORDER_COMPLETE__) { // eslint-disable-line
                  window.__ON_ORDER_COMPLETE__(false); // eslint-disable-line
                }
                if (e.response) {
                  const {
                    response: {
                      data,
                    },
                  } = e;
                  logEvent({
                    type: 'BOOKING_SERVER_REQUEST_FAILED_WITH_REPONSE_DATA',
                    bookingUid,
                  });
                  const {
                    errors,
                    resources,
                  } = data;
                  logEvent({
                    type: 'BOOKING_FAIL_DATA',
                    bookingUid,
                    errors,
                  });
                  console.log(JSON.stringify(data));
                  if (errors[0].type === 'CUSTOMER_TOTAL_DOES_NOT_MATCH_CALCULATION') {
                    const {
                      order: actualOrder,
                      products,
                      productVersion,
                    } = resources;
                    // Figure out what items changed
                    // eslint-disable-next-line react/destructuring-assignment
                    const changeEntries = getItemChangeEntries(this.props.state, actualOrder);
                    if (changeEntries.length === 0) {
                      window.alert(noChangeEntriesText); // eslint-disable-line
                    }
                    // alert the customer
                    window.alert(generateChangeEntriesText(changeEntries)); // eslint-disable-line
                    // Reset products
                    // eslint-disable-next-line react/destructuring-assignment
                    this.props.setItemsWithConversion(products, productVersion);
                  } else {
                    const errorTexts = errors.map(
                      ({ type }) => errorMappings[type] || standardMessage,
                    ).join('\n\n');
                    window.alert(errorTexts); // eslint-disable-line
                  }
                } else if (e.request) {
                  if (e.code === 'ECONNABORTED') {
                    logEvent({
                      type: 'BOOKING_SERVER_REQUEST_FAILED_BECAUSE_OF_TIMEOUT',
                      bookingUid,
                    });
                  } else {
                    logEvent({
                      type: 'BOOKING_SERVER_REQUEST_FAILED_WITHOUT_BECAUSE_OF_BROWSER',
                      bookingUid,
                    });
                  }
                  window.alert(genericErrorMessage) // eslint-disable-line
                } else {
                  logEvent({
                    type: 'BOOKING_SERVER_REQUEST_FAILED_BECAUSE_OF_UNKNOWN_REASON',
                    bookingUid,
                  });
                  window.alert(genericErrorMessage) // eslint-disable-line
                }
                this.setState({ submitting: false, bookingUid: null });
              });
          }
        });
      }
    }
  }

  onClick() {
    const { submitting } = this.state;
    if (!submitting) {
      const {
        validate,
        logEvent,
        userName: name,
        userAddress: address,
        userCity: city,
        userZipCode: zipCode,
        userPhonenumber: phonenumber,
        userEmail: email,
        paymentMethod,
        itemInconsistencies,
        setItemAmount,
        setItemSingleAmount,
        alcoholLevel,
        acceptAlkhol,
        setSubmitAlcoholError,
      } = this.props;
      if (alcoholLevel !== 'NONE' && (acceptAlkhol === false || alcoholLevel > acceptAlkhol)) {
        setSubmitAlcoholError(true);
        window.alert(`Du skal bekræfte at du er fyldt ${alcoholLevel} år for at fuldføre ordren`); // eslint-disable-line
        return;
      }
      if (itemInconsistencies.length > 0) {
        const message = itemInconsistencies.reduce(
          (messages, { status, varenr, name }) => {
            if (status === 'SOLD_OUT') {
              return [
                ...messages,
                `${name}, varenummer ${varenr} er udsolgt. Vi har fjernet den fra din kurv`,
              ];
            }
            return [
              ...messages,
              'Fejl skete',
            ];
          },
          [],
        ).join('\n\n');
        setTimeout(
          () => {
            itemInconsistencies.forEach(
              ({ varenr }) => {
                setItemAmount(varenr, 0);
                setItemSingleAmount(varenr, 0);
              },
            );
          },
          0,
        );
        window.alert(message); // eslint-disable-line
        return;
      }
      const bookingUid = makeUid();
      logEvent({
        type: 'BOOKING_STARTED',
        bookingUid,
        name,
        address,
        city,
        zipCode,
        phonenumber,
        email,
        paymentMethod,
      });
      this.setState({ validating: true, submitting: true, bookingUid }, () => {
        validate();
      });
    }
  }

  render() {
    const { paymentMethod } = this.props;
    const { submitting } = this.state;
    if (paymentMethod === paymentTypes.card) {
      return (
        <LinkButton action id="orderSubmitButton" godkend onClick={this.onClick} arrow spinCog={submitting}>
          Gå til betaling
        </LinkButton>
      );
    }
    return (
      <LinkButton action id="orderSubmitButton" godkend onClick={this.onClick} arrow spinCog={submitting}>
        Godkend ordre
      </LinkButton>
    );
  }
}

export default withRouter(connect(
  state => ({
    state,
    paymentMethod: getPaymentType(state),
    isSpecialMode: isInSpecialMode(state),
    validating: getValidating(state),
    error: hasError(state),
    message: getMessage(state),
    userName: invoiceFormSelector(state, 'name'),
    userAddress: invoiceFormSelector(state, 'address'),
    userCity: invoiceFormSelector(state, 'city'),
    userZipCode: invoiceFormSelector(state, 'zipCode'),
    userPhonenumber: invoiceFormSelector(state, 'phonenumber'),
    userEmail: invoiceFormSelector(state, 'email'),
    itemInconsistencies: getItemInconsistensies(state),
    alcoholLevel: getItemAlcoholLevel(state),
    acceptAlkhol: getAcceptAlkhol(state),
  }),
  {
    validate: validateRequest,
    setOrder,
    logEvent,
    setItemsWithConversion,
    setItemAmount,
    setItemSingleAmount,
    setSubmitAlcoholError,
  },
)(OrderSubmitButton));
